import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CookBookCategoryModel} from '../../../model/cook-book-category.model';
import {CookBookStockModel} from '../../../model/cook-book-stock.model';
import {LazyLoadEvent} from 'primeng/api';
import {environment} from '../../../../environments/environment';
import {CookBookModel} from '../../../model/cook-book.model';
import {HttpService} from '../../../service/http.service';
import {FileUpload} from 'primeng/fileupload';
import {StockMediaObjectModel} from '../../../model/stock-media-object.model';
import {StockTransfersModel} from '../../../model/stock-transfers.model';
import {FlashMessage, FlashMessageModel} from '../../../model/flash-message.model';
import {FlashMessageService} from '../../../service/flash-message.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CookBookCategoryService} from '../../../service/cook-book-category.service';
import {StockModel} from 'src/app/model/stock.model';
import {CookBookItemModel} from '../../../model/cook-book-item.model';
import {StockVariantModel} from '../../../model/stock-variant.model';

@Component({
  selector: 'app-cook-book-stocks',
  templateUrl: './cook-book-stocks.component.html',
  styleUrls: ['./cook-book-stocks.component.scss']
})
export class CookBookStocksComponent implements OnInit {
  loading: boolean;
  cookBookStocks: CookBookStockModel[] = [];
  findCookBookStocks: CookBookStockModel[] = [];
  selectedStock: CookBookStockModel;
  parameters = {
    id: '',
    name: '',
    code: '',
    pagination: true,
    category: '',
    sector: '',
    itemsPerPage: 20,
    page: 1,
  };
  total: number;
  response: any;
  entity: string;
  categories: CookBookCategoryModel[] = [];
  mainCategories: CookBookCategoryModel[] = [];
  searchStocks = false;
  invoiceInQapera = false;
  stocks: StockModel[] = [];
  selectedStocks: any[] = [];
  product: any;
  invoices: any[] = [];
  categoriesNameArray: any[] = [];
  mainCategoriesNameArray: any[] = [];
  date: Date[];
  startDate: any;
  currencySymbol: string;
  stockInCookBook: any[] = [];
  stockInCookBookDisplay: boolean;
  tableLoading: boolean;
  newCookBookStock: CookBookStockModel;

  constructor(private translate: TranslateService,
              private http: HttpService,
              private httpClient: HttpClient,
              private categoryService: CookBookCategoryService,
              private flashMessageService: FlashMessageService) {
    const currencyData = JSON.parse(window.localStorage.getItem('currency'));
    this.currencySymbol = currencyData.symbol;
  }

  ngOnInit(): void {

  }

  load(event: LazyLoadEvent = null): void {
    this.categoriesNameArray = [];
    this.mainCategoriesNameArray = [];
    this.loading = true;
    if (event) {
      this.parameters.page = event.first / this.parameters.itemsPerPage + 1;
    }
    this.parameters[`order[name]`] = 'ASC';

    if (event && event.rows) {
      this.parameters.itemsPerPage = event.rows;
    }

    if (event?.sortField) {
      // @ts-ignore
      this.parameters = Object.fromEntries(Object.entries(this.parameters).filter(([k]) => k.indexOf('order') < 0));
      this.parameters[`order[${event.sortField}]`] = event.sortOrder > 0 ? 'ASC' : 'DESC';
    }
    // @ts-ignore
    this.parameters = Object.fromEntries(Object.entries(this.parameters).filter(([_, v]) => v !== ''));
    this.http.get(CookBookStockModel.IRI, this.parameters).subscribe(response => {
      this.cookBookStocks = response['hydra:member'];
      this.cookBookStocks.map((item, i) => {
        this.mainCategoriesNameArray.push(item.mainCategory?.name);
        this.categoriesNameArray.push(item.category?.name);
        item.category = item.category ? item.category['@id'] : '';
        item.mainCategory = item.mainCategory ? item.mainCategory['@id'] : '';
      });
      this.total = response['hydra:totalItems'];
      this.loadSearchData();
      this.loading = false;
    });
  }

  loadSearchData(): void {
    this.loading = true;
    this.categoryService.getItemsAction({type: 'stock', pagination: false, itemsPerPage: 300});
    this.categoryService.getItems().subscribe(response => {
      this.categories = response;
      // this.mainCategories = this.categories.filter(category => category.type === 'main');
    });
    this.http.get(CookBookCategoryModel.IRI, {type: 'stock', parent: 'main', pagination: false, itemsPerPage: 300}).subscribe(res => {
      this.mainCategories = res['hydra:member'];
    });

  }
  edit(product): void {
    console.log(product);
  }

  saveCookBookStock(row, i): void {
    this.categoriesNameArray[i] = row.category ? row.category.name : '';
    this.mainCategoriesNameArray[i] = row.mainCategory ? row.mainCategory.name : '';
    this.http.put(`${CookBookStockModel.IRI}/${row.id}`, row).then((response: CookBookStockModel) => {
      if (response) {
        this.cookBookStocks[i] = response;
        this.flashMessageService.updateMessages(new FlashMessageModel(FlashMessage.Success));
        this.load();
      }
    });
  }

  changeCategory(event, i): void  {
    const findIndex = this.categories.findIndex(obj =>  obj['@id'] === event.value );
    this.cookBookStocks[i].category = this.categories[findIndex]['@id'];
  }
  changeMainCategory(event, i): void  {
    const findIndex = this.mainCategories.findIndex(obj =>  obj['@id'] === event.value );
    this.cookBookStocks[i].mainCategory = this.mainCategories[findIndex]['@id'];
  }

  async upload(event, entity: string, fileUpload: FileUpload): Promise<void> {
    this.response = {};

    this.entity = entity;
    this.loading = true;

    for (const file of event.files) {
      const fd = new FormData();
      fd.append('file', file);

      await this.http.post(`/api/data/import/${entity}`, fd).then((response: StockMediaObjectModel) => {
        this.response = response;
      }).catch(error => {
      });
    }

    fileUpload.clear();

    this.loading = false;
  }

  updatePrice(product): void {
    this.http.get(CookBookModel.IRI + '/stock_price_update/' + product.id).subscribe(response => {
      if (response) {
        this.flashMessageService.updateMessages(new FlashMessageModel(FlashMessage.Success));
        this.load();
      }
    });
  }

  openSearchStocks(product): void {
    this.loading = true;
    this.product = product;
    this.http.get(StockModel.IRI + '/same_recipe_in_stock/' + product.searchName).subscribe(response => {
      this.stocks = response;
      this.searchStocks = true;
      this.loading = false;

    });
  }

  openInvoiceInQapera(product, $date = null): void {
    this.loading = true;
    this.product = product;

    if ($date) {
      this.http.get(StockModel.IRI + '/invoice_cook_books/' + product.id, {date: this.startDate}).subscribe(response => {
        this.invoices = response;
        this.invoiceInQapera = true;
        this.loading = false;
      });
    } else {
      this.http.get(StockModel.IRI + '/invoice_cook_books/' + product.id).subscribe(response => {
        this.invoices = response;
        this.invoiceInQapera = true;
        this.loading = false;
      });
    }

  }

  updateSelectedStocks(): void {
    this.selectedStocks.forEach(stock => {
      stock.name = this.product.name;
      stock.variants[0].name = this.product.name;
      stock.cookBookStock = this.product.id;
      delete stock.unit;
      delete stock.category;

      this.http.put(`${StockModel.IRI}/${stock.id}`, stock).then((response: StockModel) => {
        if (response) {
          this.flashMessageService.updateMessages(new FlashMessageModel(FlashMessage.Success));
        }
      });
    });

    setTimeout(() => {
      this.openSearchStocks(this.product);
    }, 1000);

    this.selectedStocks = [];
  }

  onSelectDate(event): void {
    const start = event;
    this.date = event;
    this.startDate = this.getFormattedDate(start);
  }

  getFormattedDate(date: Date): string {
    const year = date.getFullYear();
    const month = this.addLeadingZero(date.getMonth() + 1);
    const day = this.addLeadingZero(date.getDate());

    return `${year}-${month}-${day}`;
  }

  addLeadingZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
  deleteCookBookStock(product, i): void {
    this.selectedStock = product;
    this.stockInCookBook = [];

    this.http.get(CookBookItemModel.IRI, {
      cookBookStock: product.id
    }).subscribe(response => {
      if (response['hydra:totalItems'] > 0){
        this.stockInCookBookDisplay = true;
        this.stockInCookBook = response['hydra:member'];
      }else {
        this.http.delete(CookBookStockModel.IRI + '/' + product.id).then(() => {
          this.tableLoading = false;
        });
      }
    });
  }

  searchVariant = (event) => {
    this.http.get(CookBookStockModel.IRI, {name: event.query}).subscribe((response: StockModel) => {
      this.findCookBookStocks = response['hydra:member'];
    });
  }
  onVariantSelect(event): void {
    this.newCookBookStock = event;
  }

  changeStockInAllCookBook(): void {
    /**
     * @Route("/api/cook_book_items/change_stock_in_recipes/{oldStock}/{newStock}")
     */
    console.log(this.selectedStock, this.newCookBookStock);

    this.http.get(CookBookItemModel.IRI + '/change_stock_in_recipes/' + this.selectedStock.id + '/' + this.newCookBookStock.id).subscribe(response => {
      this.stockInCookBookDisplay = false;
      this.load();
    });
  }
}
